import { Flex, Box, Text, Button, Image, Heading, useColorModeValue, useColorMode } from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import Boxx from '../../components/common/boxhome/boxx';
import Footer from "../../components/footer/footer";
import { useNavigate } from 'react-router-dom';

const Services = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const navigate = useNavigate();
    const { colorMode, toggleColorMode } = useColorMode();

    const heroServices = [
        {
            text: "Redefined Strategies",
            imgSrc: "../assets/images/svg/serviceherosection.svg",
        },
        {
            text: "Realistic Reach",
            imgSrc: "../assets/images/svg/Layer 2.svg",
        },
        {
            text: "Revamped Revenue",
            imgSrc: "../assets/images/svg/Layer 2 (1).svg",
        },
    ];

    const buttonServices = [
        {
            title: "Digital Branding Solutions",
            description: "Build a powerful and consistent brand identity across all digital platforms to leave a lasting impact on your audience.",
            url: "/digitalbranding",
        },
        {
            title: "Awareness Growth Solutions",
            description: "Amplify your brand’s visibility with targeted strategies that boost awareness and position you as a leader in your industry.",
            url: "/awarenesssoutions",
        },
        {
            title: "Revenue Growth Solutions",
            description: "Drive conversions and accelerate your revenue with data-driven marketing solutions tailored to scale your business.",
            url: "/revenuegrowth",
        },
        {
            title: "Social Media Management",
            description: "Manage your social presence effectively, engaging your audience with strategic content that grows your brand organically.",
            url: "/socialmedia",
        },
        {
            title: "SEO",
            description: "Enhance your search rankings with SEO strategies that attract organic traffic and improve your site’s discoverability.",
            url: "/seo",
        },
        {
            title: "Performance Marketing",
            description: "Maximize your marketing ROI with performance-driven campaigns that are focused on achieving measurable, impactful results.",
            url: "/performancemarketing",
        },
    ];

    useEffect(() => {
        window.scrollTo({ top: 0 });

        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % heroServices.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [heroServices.length]);


    const bg = useColorModeValue('white', '#1C1C1C')
    const color = useColorModeValue('#FFFFF', 'white')

    return (
        <Flex
            bg={bg}
            direction="column"
            align="center"
            justify="center"
            width="100%"
            padding="0"
            overflowX="hidden"
        >
            {/* Services Header */}
            <Box textAlign="center" mt={{ base: "30px", md: "50px" }}>
                <Text fontSize={{ base: "14px", md: "28px" }} color={color} fontFamily="'Gilroy-Regular', sans-serif">
                    Services
                </Text>
            </Box>

            <Box textAlign="center" mt={{ base: '16px', md: '4.16%' }} mb={{ base: '20px', md: '40px' }}>
                <Text
                    fontFamily="'Gilroy-SemiBold', sans-serif"
                    fontSize={{ base: '32px', md: '64px' }}
                    fontWeight="400"
                    lineHeight={{ base: '40px', md: '58px' }}
                    letterSpacing="-0.25px"
                    color={color}
                // textShadow="2px 2px 8px rgba(0, 0, 0, 0.5)"
                >
                    <span style={{ fontFamily: "'Gilroy-Regular', sans-serif" }}>What</span>
                    <span style={{ color: '#FE3A3A', fontFamily: "'Cags Hetonal', sans-serif" }}> we offer </span>
                </Text>
                <Box
                    width="auto"
                    height="auto"
                    mx="auto"
                    mt="10px"
                    border="1.7px solid"
                    sx={{
                        borderImageSource: colorMode === 'light'
                            ? 'linear-gradient(270deg, #FFFFFF 0%, #C92E2E 50%, #FFFFFF 100%)'
                            : 'linear-gradient(270deg, #1C1C1C 0%, #C92E2E 50%, #1C1C1C 100%)',
                        borderImageSlice: 1,
                    }}
                    borderRadius="md"
                />
            </Box>

            {/* Service Image and Text */}
            <Flex
                direction={{ base: "column", md: "row" }}
                align="center"
                justify="center"
                width="100%"
                paddingX={{ base: "0", lg: "50px" }}
                mx="auto"
                py={{ base: "30px", lg: "100px" }}
            >
                <Box
                    textAlign="center"
                    flex="1"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    marginRight={{ base: "0", md: "50px" }}
                >
                    <Text
                        fontFamily="'Gilroy-SemiBold', sans-serif"
                        fontSize={{ base: "30px", md: "60px", lg: "90px" }}
                        fontWeight="400"
                        lineHeight={{ base: "40px", md: "80px", lg: "192.99px" }}
                        letterSpacing="-0.6185532808303833px"
                        whiteSpace="nowrap"
                        color={color}
                    >
                        <span style={{ fontFamily: "'Gilroy-SemiBold', sans-serif" }}>
                            {heroServices[currentIndex].text.split(' ')[0]}{' '}
                        </span>
                        <span style={{ color: '#FE3A3A', fontFamily: "'Cags Hetonal', sans-serif" }}>
                            {heroServices[currentIndex].text.split(' ')[1]}
                        </span>
                    </Text>
                </Box>

                <Box
                    flex="1"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    height={{ base: "100px", md: "400px", lg: "500px" }}
                    overflow="hidden"
                >
                    <Image
                        src={heroServices[currentIndex].imgSrc}
                        alt="Service Illustration"
                        objectFit="contain"
                        width={{ base: "90%", md: "80%" }}
                        height="100%"
                        marginX={{ base: "20px", md: "0" }}
                    />
                </Box>

            </Flex>
            <Box textAlign="center" mt={{ base: "30px", md: "50px" }}>
                <Text fontSize={{ base: "14px", md: "28px" }} color={color} fontFamily="'Gilroy-Regular', sans-serif">
                    Service We Offer
                </Text>
            </Box>

            <Box
                mt="3%"
                textAlign="center"
                width="auto"
                height="auto"
                position="relative"
                left="auto"
                gap="0px"
                opacity="1"
            >
                <Heading
                    fontFamily="Gilroy-SemiBold"
                    fontSize={{ base: '32px', md: '64px' }}
                    fontWeight="400"
                    lineHeight={{ base: '40px', md: '78px' }}
                    letterSpacing="-0.25px"
                    color={color}
                >
                    We strongly identify <span style={{ color: '#FE3A3A', fontFamily: "'Cags Hetonal', sans-serif" }}>your business</span>
                </Heading>
                <Heading
                    fontFamily="Gilroy-SemiBold"
                    fontSize={{ base: '32px', md: '64px' }}
                    fontWeight="400"
                    lineHeight={{ base: '40px', md: '78px' }}
                    letterSpacing="-0.25px"
                    color={color}
                >
                    <span style={{ color: '#FE3A3A', fontFamily: "'Cags Hetonal', sans-serif" }}>growth</span> potential
                </Heading>
            </Box>

            {/* Services List Section */}
            <Box
                width="100%"
                padding="auto"
                borderRadius="20px"
                mt="50px"
                maxHeight="600px"
                overflowY="auto"
                position="relative"
                css={{
                    '&::-webkit-scrollbar': {
                        display: 'none',
                    },
                    '&::-moz-scrollbar': {
                        display: 'none',
                    },
                }}
            >
                <Box height="100%" padding="10px">
                    <Flex direction="column" align="center">
                        {buttonServices.map((service, index) => (
                            <Flex
                                key={index}
                                direction={{ base: "column", md: "row" }}
                                align="center"
                                justify="space-between"
                                width={{ base: "100%", md: "95%" }}
                                height={{ base: "auto", md: "250px" }}
                                padding={{ base: "5px", md: "51px 58px" }}
                                gap="10px"
                                borderRadius={{ base: "10px", md: "30px" }}
                                bg={{ base: "white", md: "transparent" }}
                                bgGradient={{ base: "none", md: "linear(to-r, white 80%, gray.300 80%)" }}
                                opacity="0.9"
                                boxShadow="lg"
                                mx="auto"
                                mb="33px"
                                style={{ marginBottom: index === buttonServices.length - 1 ? '30px' : '20px' }}
                            >
                                <Box textAlign={{ base: "center", md: "left" }} flex="1">
                                    <Text
                                        fontFamily="'Gilroy-SemiBold', sans-serif"
                                        fontSize={{ base: "22px", md: "32px" }}
                                        color="black"

                                        mb={{ base: "1px" }}
                                    >
                                        {service.title}
                                    </Text>
                                </Box>

                                <Box textAlign={{ base: "left", md: "left" }} flex="2" px="20px">
                                    <Text
                                        fontFamily="'Gilroy-Regular', sans-serif"
                                        fontSize={{ base: "12px", md: "28px" }}
                                        color="gray.600"
                                        my={{ base: "5px" }}
                                        textAlign='justify'
                                    >
                                        {service.description}
                                    </Text>
                                </Box>

                                <Box flex="1" display="flex" justifyContent={{ base: "center", md: "flex-end" }}>
                                    <Button
                                        bg="#FE3A3A"
                                        color="white"
                                        height={{ base: "40px", md: "auto" }}
                                        width={{ base: "214px", md: "66%" }}
                                        padding="16px 20px"
                                        gap="0px"
                                        borderRadius="10px"
                                        opacity="1"
                                        _hover={{ bg: "#e23434" }}
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        onClick={() => navigate(service.url)}
                                        mt={{ base: "5px", md: "10px" }}
                                    >
                                        <Text
                                            fontFamily="'Gilroy-SemiBold', sans-serif"
                                            fontSize={{ base: "16px", md: "18px" }}
                                            fontWeight="400"
                                        >
                                            Explore Service
                                        </Text>
                                    </Button>
                                </Box>
                            </Flex>
                        ))}
                    </Flex>
                </Box>
            </Box>

            <Box mt="22px" color={color}>
                <Text fontFamily="'Gilroy-Regular', sans-serif" fontSize={{ md: "28px", base: "12px" }} color={color}>
                    Get in touch
                </Text>
            </Box>
            <Boxx />
            <Footer />
        </Flex>
    );
};

export default Services;